(($) => {
    let $window, $html, $body;
    let $container, $bar;

    window.addEventListener('load', init);

    function init() {
        $container = $('#footer-cta-bar');

        if ($container.length === 0) {
            return false;
        }

        $window = $(window);
        $html = $('html');
        $body = $('body');
        $header = $('header');
        $footer = $('footer');

        $bar = $container.find('.bar');

        if (isScrolling()) {
            showBar();
        }

        bind();
    }

    function bind() {
        $($window, $html, $body).on('scroll', onWindowScroll);
        $html.on('nav:scrolling', onNavScrolling);
        $html.on('nav:static', onNavStatic);
    }
    
    function isScrolling() {
        return ($window.scrollTop() > $header.height() && $window.scrollTop() < $footer.position().top - $window.height()) ? true : false;
    }

    function isVisible() {
        return ($container.hasClass('show')) ? true : false;
    }

    function showBar() {
        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'show_footer_cta_bar' }}));
        $container.addClass('show');
    }

    function hideBar() {
        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'hide_footer_cta_bar' }}));
        $container.removeClass('show');
    }

    function onWindowScroll(event) {
        if (!event instanceof Event) {
            return false;
        }

        if (isScrolling() && !isVisible()) {
            showBar();
            return true;
        }

        if (!isScrolling() && isVisible()) {
            hideBar();
            return true;
        }

        return false;
    }

    function onNavScrolling(event) {
        if (!event instanceof Event) {
            return false;
        }

        showBar();
    }

    function onNavStatic(event) {
        if (!event instanceof Event) {
            return false;
        }

        hideBar();
    }

})(jQuery, Cookies);